import React, { useMemo } from 'react';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';

import { getPageTitleByUrl } from '@/utils';

function SEO({ uri }) {
  const { site, file } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        file(relativePath: {eq: "medigniton.image.png"}) {
          publicURL
        }
      }
    `,
  );

  const title = useMemo(() => getPageTitleByUrl(uri), [uri]);
  const { title: metaTitle, description, author } = site.siteMetadata;
  const baseUrl = process.env.GATSBY_URL;

  return (
    <Helmet
      htmlAttributes={{ lang: 'en' }}
      title={metaTitle}
      titleTemplate={`%s | ${title}`}
    >
      <link rel="preload" href="/fonts/NeueHaasUnicaProRegular.woff" as="font" type="font/woff" crossOrigin="anonymous" />
      <link rel="preload" href="/fonts/NeueHaasUnicaProRegular.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      <link rel="preload" href="/fonts/NeueHaasUnicaProBold.woff" as="font" type="font/woff" crossOrigin="anonymous" />
      <link rel="preload" href="/fonts/NeueHaasUnicaProBold.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      <meta name="description" content={description} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:url" content={baseUrl} />
      <meta property="og:site_name" content={metaTitle} />
      <meta property="og:description" content={description} />
      {file && <meta property="og:image" content={baseUrl + file.publicURL} />}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:creator" content={author} />
      <meta property="twitter:site" content={baseUrl} />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={description} />
      {file && <meta property="twitter:image" content={baseUrl + file.publicURL} />}
    </Helmet>
  );
}

SEO.propTypes = {
  uri: PropTypes.string.isRequired,
};

export default SEO;
